// extracted by mini-css-extract-plugin
module.exports = {"container":"client-side-video-player_container__xK6ID","error-message":"client-side-video-player_error-message__1JRmf","loader":"client-side-video-player_loader__B3a34"};